/**
 * 公共面包屑
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/4/12      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from "react";
import { Link } from "react-router-dom";
import Lang from "@components/Lang/Lang";
import { Breadcrumb } from "antd";
class CommonBreadcrumb extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items:[]
        };
    }
    getList(list=[]){
        let items = [
            {
                title: <Link to="/">
                    <Lang id="ShouYe">首页</Lang>
                </Link>
            }
        ]
        list.forEach(item=>{
            if(item.link){
                items.push({title:<Link to={item.link}>
                        {item.name}
                    </Link>})
            }else {
                items.push({title:item.name})
            }
        })
        return items;
    }
    render() {
        const { list } = this.props;
        return (
            <Breadcrumb items={this.getList(list)}>
                {/*<Breadcrumb.Item key="home">*/}
                    {/*<Link to="/">*/}
                        {/*<Lang id="ShouYe">首页</Lang>*/}
                    {/*</Link>*/}
                {/*</Breadcrumb.Item>*/}
                {/*{this.props.list.map(function (item, index) {*/}
                    {/*if (!item.link) {*/}
                        {/*return (*/}
                            {/*<Breadcrumb.Item key={index}>*/}
                                {/*{item.name}*/}
                            {/*</Breadcrumb.Item>*/}
                        {/*);*/}
                    {/*} else {*/}
                        {/*return (*/}
                            {/*<Breadcrumb.Item key={index}>*/}
                                {/*<Link to={item.link}>{item.name}</Link>*/}
                            {/*</Breadcrumb.Item>*/}
                        {/*);*/}
                    {/*}*/}
                {/*})}*/}
            </Breadcrumb>
        );
    }
}

CommonBreadcrumb.defaultProps = {
    //[{name:string,link:strng}]
    list: [],
};

CommonBreadcrumb.propTypes = {};
export default CommonBreadcrumb;
